import { render, staticRenderFns } from "./simple-wrapper.vue?vue&type=template&id=36edcd4e&scoped=true&"
import script from "./simple-wrapper.vue?vue&type=script&lang=js&"
export * from "./simple-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./simple-wrapper.vue?vue&type=style&index=0&id=36edcd4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36edcd4e",
  null
  
)

export default component.exports